import { render, staticRenderFns } from "./EatingStudyCard.vue?vue&type=template&id=2bd60ee4&scoped=true&"
import script from "./EatingStudyCard.vue?vue&type=script&lang=js&"
export * from "./EatingStudyCard.vue?vue&type=script&lang=js&"
import style0 from "./EatingStudyCard.vue?vue&type=style&index=0&id=2bd60ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd60ee4",
  null
  
)

export default component.exports